import { render, staticRenderFns } from "./StudioProductReviews.vue?vue&type=template&id=cd2234b8&scoped=true&"
import script from "./StudioProductReviews.vue?vue&type=script&lang=js&"
export * from "./StudioProductReviews.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd2234b8",
  null
  
)

export default component.exports